import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type AnnouncementRow = {
  id: string;
  body: string;
  active: boolean;
  starts_at: string | null;
  ends_at: string | null;
  audience_segment_id: string | null;
  tier_scope: string[] | null;
  partner_type_scope: string[] | null;
  created_by: string | null;
  created_at: string;
};

// GET /api/settings/announcements — admin board listing.
export function useAnnouncements() {
  return useQuery<AnnouncementRow[], ApiClientError>({
    queryKey: queryKeys.settings.announcements(),
    queryFn: () => apiFetch<AnnouncementRow[]>("/settings/announcements"),
  });
}
